import React from 'react';

import { NewFeatureBadge } from '../../AZmed/Components/NewFeatureBadge/NewFeatureBadge';
import { isReportHiddenHere } from '../../AZmed/Data/reportAvailability';
import ReportPanel, { REPORT_PANEL_RELEASE } from './ReportPanel.js';

export default {
  /**
   * Only required property. Should be a unique value across all extensions.
   */
  id: 'report-panel-extension',
  get version() {
    return window.version;
  },

  getPanelModule() {
    return {
      menuOptions: [
        {
          icon: 'clipboard',
          // Namespace prefixed because ToolbarRow, which renders this label, is
          // bound to `Common`. It calls t() on the key.
          label: 'ReportPanel:Report',
          target: 'report-panel',
          // Marks the button while the panel is closed: the badge in the panel
          // header is only visible once it is open. A bare "!" rather than the
          // full label, which does not fit the toolbar, and which needs no
          // translation.
          adornment: (
            <NewFeatureBadge
              newInVersion={REPORT_PANEL_RELEASE}
              variant="corner"
              label="!"
            />
          ),
          // Disabled means absent from the toolbar here, see ToolbarRow.js:95.
          // `filters.vertical` is the one input of this predicate ToolbarRow does
          // not watch: it recomputes the button groups on a study or active
          // viewport change and on derived display sets landing
          // (ToolbarRow.js:126-139, :173-174), never on a store change, and
          // render() just reads the cached field. Sound only because nothing
          // mounted in the viewer dispatches updateVertical — its three call
          // sites all sit in StudiesLayout, which this route unmounts. Dispatch
          // it from the viewer and this button stays stale until one of those
          // fires.
          isDisabled: isReportHiddenHere,
        },
      ],
      components: [
        {
          id: 'report-panel',
          component: ReportPanel,
        },
      ],
      defaultContext: ['VIEWER'],
    };
  },
};
